document.addEventListener('DOMContentLoaded', () => {
    const setupToggleBehavior = (container) => {
        const defaultState = container.dataset.defaultState || "expanded"; // Fetch the default state
        const addonParents = container.querySelectorAll('.addon-parent');
    
        addonParents.forEach((parent) => {
            const toggleButton = parent.querySelector('.addon-toggle');
            const childrenContainer = parent.querySelector('.addon-subitems');
    
            // Set the initial visibility based on the default state
            if (childrenContainer) {
                if (defaultState === "expanded") {
                    childrenContainer.classList.remove('hidden'); // Default to visible
                } else {
                    childrenContainer.classList.add('hidden'); // Default to hidden
                }
            }
    
            // Toggle visibility for child container
            if (toggleButton && childrenContainer) {
                toggleButton.addEventListener('click', () => {
                    childrenContainer.classList.toggle('hidden');
                });
            }
        });
    };
    // Initialize selection tracking
    const selectedItems = [];

    // Utility function to update visual feedback
    const updateSelectedVisuals = (item, isSelected) => {
        if (isSelected) {
            item.classList.add('selected');
        } else {
            item.classList.remove('selected');
        }
    };

    // Collect selected items from the DOM
    const collectSelectedItems = () => {
        selectedItems.length = 0; // Reset the array

        document.querySelectorAll('.addon-parent').forEach((parent) => {
            const parentId = parent.dataset.addonId;
            const parentTitle = parent.querySelector('.addon-toggle').textContent.trim();

            const selectedSubItems = [];
            parent.querySelectorAll('.addon-subitems .selected').forEach((subItem) => {
                selectedSubItems.push({
                    id: subItem.dataset.subitemid.toString(),
                    value: subItem.dataset.value,
                    price: parseFloat(subItem.dataset.price),
                });
            });
            if (selectedSubItems.length > 0) {
                selectedItems.push({
                    id: parentId,
                    title: parentTitle,
                    subItems: selectedSubItems,
                });
            }
        });
        updatePriceDisplay();

    };

    const updatePriceDisplay = () => {
        const basePriceElement = document.querySelector('.woocommerce-Price-amount');
        if (!basePriceElement) return;
        const basePrice = parseFloat(basePriceElement.dataset.basePrice || 0);
        const addonPrice = selectedItems.reduce((total, addon) => {
            return total + addon.subItems.reduce((subTotal, subItem) => subTotal + subItem.price, 0);
        }, 0);

        const newPrice = (basePrice + addonPrice).toFixed(2);
        basePriceElement.textContent = `${newPrice} ${basePriceElement.dataset.currency}`;
    };


    // Attach event listeners to sub-items
    const setupItemSelection = (container) => {
        // Handle non-radio items (buttons, colors, images)
        container.querySelectorAll('.addon-subitems .subitem-button, .color-option, .subitem-image').forEach((item) => {
            item.addEventListener('click', () => {
                const parent = item.closest('.addon-subitems'); // Find the parent sub-items container

                // Reset selection in the same group
                parent.querySelectorAll('.selected').forEach((selectedItem) => {
                    selectedItem.classList.remove('selected');
                });

                // Mark the clicked item as selected
                item.classList.add('selected');
                collectSelectedItems(); // Update the selection tracking
            });
        });

        // Handle radio buttons (grouped selections)
        container.querySelectorAll('.addon-subitems input[type="radio"]').forEach((radio) => {
            radio.addEventListener('change', () => {
                const group = radio.name;

                // Reset selection visuals for all items in the group
                document.querySelectorAll(`.addon-subitems input[name="${group}"]`).forEach((item) => {
                    updateSelectedVisuals(item.parentElement, item.checked);
                });

                collectSelectedItems(); // Update the selection tracking
            });
        });
    };

    // Attach selected items to the Add to Cart form
    const attachSelectedItemsToCart = () => {
        const hiddenField = document.querySelector('input[name="selected_addons"]');
        if (hiddenField) {
            collectSelectedItems();
            hiddenField.value = JSON.stringify(selectedItems);
        }
    };


    const rootContainer = document.querySelector('.product-addons');
    if (rootContainer) {
        setupItemSelection(rootContainer);
        setupToggleBehavior(rootContainer);

        // Hook into Add to Cart button
        const addToCartForm = document.querySelector('form.cart');
        if (addToCartForm) {
            addToCartForm.addEventListener('submit', () => {
                attachSelectedItemsToCart();
            });
            addToCartForm.addEventListener('submit', (event) => {
                let requiredAddons = rootContainer.dataset.requiredAddons;
                if (selectedItems.length === 0 && requiredAddons === "yes") {
                    event.preventDefault();
                    alert('Please select an addon before adding this product to your cart.');
                }
            });
        }
        const basePriceElement = document.querySelector('.woocommerce-Price-amount');
        if (basePriceElement) {
            // Store the base price for reference
            const basePrice = parseFloat(basePriceElement.textContent.replace(/[^0-9.]/g, ''));
            basePriceElement.dataset.basePrice = basePrice;
            basePriceElement.dataset.currency = basePriceElement.textContent.replace(/[0-9.,]/g, '').trim();
        }
    }
});
